import { ReactNode } from "react"
import {
  Accordion,
  Panel,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

export type AccordionPanelItemProps = {
  key: string
  title: ReactNode
  children: ReactNode
}

export type AccordionPanelsProps = {
  items: AccordionPanelItemProps[]
}

export default function AccordionPanels({ items }: AccordionPanelsProps) {
  const [_, theme] = useStyletron()

  return (
    <Accordion size="standard" stateReducer={(__, newState) => newState}>
      {items.map(({ key, title, children }) => {
        const regex = /[ ,.?]/gm

        const dataAttribute =
          typeof title === "string"
            ? title
                .toLowerCase()
                .split(regex)
                .filter((el) => el !== "")
                .join("-")
            : null

        const panelOverrides = {
          Content: {
            style: () => ({
              padding: `0 ${theme.sizing.scale700} ${theme.sizing.scale600}`,
            }),
          },
          ...(dataAttribute
            ? {
                PanelContainer: {
                  props: { "data-attr": `faq-${dataAttribute}` },
                },
              }
            : {}),
        }

        return (
          <Panel key={key} title={title} overrides={panelOverrides}>
            <ParagraphMedium
              as="span"
              color="contentSecondary"
              whiteSpace="pre-wrap"
            >
              {children}
            </ParagraphMedium>
          </Panel>
        )
      })}
    </Accordion>
  )
}
